/* eslint-disable */
import React from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { useI18n } from '../../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../../i18n/locales/defaultResources';
import { useTranslationContext } from '../../../../../context/TranslationContext';
import { BusinessPartnerSelectorItem } from '../types';

export type AccessOnBehalfControlProps = {
  aobActivationError: TranslationKeys | undefined;
  aobActive?: boolean;
  aobInputValue: string | undefined;
  aobInputValueChanged: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBPSelect: (bp: BusinessPartnerSelectorItem) => void;
  onAobStart: (bp: string) => void;
  onAobEnd: () => void;
};

const AccessOnBehalfControl: React.FC<AccessOnBehalfControlProps> = ({
                                                                       aobActivationError,
                                                                       aobInputValue,
                                                                       aobInputValueChanged,
                                                                       onAobStart,
                                                                     }) => {
  const { t } = useI18n();
  const { isTranslationMode } = useTranslationContext();

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      onAobStart(aobInputValue ?? '');
    }
  };

  return (
    <>
      <h3 style={{ marginBottom: '6px' }}>
        {t(TranslationKeys.accessonbehalfactivationbox_placeholder_enterbpName)}{' '}
      </h3>
      {isTranslationMode ? (
        <div
          style={{
            border: '1px solid #d3d3d3',
            padding: '12px',
            borderRadius: '4px',
            background: 'white',
            minHeight: '56px',
          }}
        >
          {t(
            TranslationKeys.accessonbehalfactivationbox_placeholder_enterbpName,
          )}
        </div>
      ) : (
        <TextField
          placeholder={
            t(
              TranslationKeys.accessonbehalfactivationbox_placeholder_enterbpName,
            ) as string
          }
          value={aobInputValue}
          onChange={aobInputValueChanged}
          style={{ background: 'white' }}
          onKeyDown={handleKeyDown}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => {
                    onAobStart(aobInputValue ?? '');
                  }}
                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}
      {aobActivationError && (
        <span style={{ color: '#c45d5d' }}>{t(aobActivationError)}</span>
      )}
    </>
  );
};

export default AccessOnBehalfControl;
